


























































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";
import { Translate } from "../../services/language/entities/translate.interface";
import constants from "../../config/constants";

@Component
export default class UpdatePostDialog extends Vue {
  @Prop() dialogUpdate!: boolean;
  @Prop() post!: any;
  @Prop() page!: number;

  hosted = false;
  currentHosted = false;
  file = null;
  fileRestricted = false;
  attachedFile = "";
  newAttachedFile = null;
  newFile = null;
  hostedURL = "";
  newHostedURL = "";
  mediaType = "";
  newMediaType = "";
  link = "";
  mediaRules = [rules.media];
  generalRules = [rules.notEmpty];
  name: Array<Translate> = [];
  description: Array<Translate> = [];
  linkName: Array<Translate> = [];

  $refs!: {
    formUpdate: HTMLFormElement;
  };

  valid = true;
  loadingUpdate = false;
  snackbarSuccessUpdate = false;
  snackbarErrorUpdate = false;

  private mounted(): void {
    if (this.post.postMediaType == "HOSTED") {
      this.hostedURL = this.post.postMediaURL;
      this.mediaType = this.post.postMediaType;
      this.hosted = true;
      this.currentHosted = true;
    } else {
      this.file = this.post.postMediaURL;
      this.mediaType = this.post.postMediaType;
      this.hosted = false;
      this.currentHosted = false;
    }
    this.attachedFile = this.post.postFile;
    this.fileRestricted = this.post.postFileRestricted;
    this.post.postNameTranslate.forEach((translate: Translate) => {
      this.name.push({
        languageName: translate.languageName,
        iso: translate.iso,
        text: translate.text,
      });
    });

    this.post.postDescriptionTranslate.forEach((translate: Translate) => {
      this.description.push({
        languageName: translate.languageName,
        iso: translate.iso,
        text: translate.text,
      });
    });

    this.post.postLinkNameTranslate.forEach((translate: Translate) => {
      this.linkName.push({
        languageName: translate.languageName,
        iso: translate.iso,
        text: translate.text,
      });
    });
  }

  private getMediaFormat(event: any): void {
    if (event) {
      const file = event || event.dataTransfer.files;
      const type = file.type !== undefined ? file.type : "error/error";
      this.newMediaType = type.split("/")[1].toUpperCase();
    } else {
      this.newFile = null;
      this.newMediaType = "";
    }
  }

  private cancelUpdate(): void {
    this.$emit("cancelUpdate");
  }

  private updatePost(): void {
    const nameTranslate = this.name.map((translate: Translate) => {
      return { iso: translate.iso, text: translate.text };
    });
    const descriptionTranslate = this.description.map(
      (translate: Translate) => {
        return { iso: translate.iso, text: translate.text };
      }
    );
    const linkNameTranslate = this.linkName.map((translate: Translate) => {
      return { iso: translate.iso, text: translate.text };
    });
    this.loadingUpdate = true;
    this.$store
      .dispatch("post/updatePost", {
        postId: this.post.postID,
        terms: [
          {
            name: this.post.postNameTerm,
            translate: nameTranslate,
          },
          {
            name: this.post.postDescriptionTerm,
            translate: descriptionTranslate,
          },
          {
            name: this.post.postLinkNameTerm,
            translate: linkNameTranslate,
          },
        ],
        mediaUrl: this.file !== null ? this.file : this.hostedURL,
        mediaType: this.mediaType,
        status: this.post.postStatus,
        currentMedia: this.file !== null ? this.file : this.hostedURL,
        newMediaFile: this.newFile !== null ? this.newFile : undefined,
        newMediaType: this.newMediaType !== `` ? this.newMediaType : undefined,
        hosted: this.hosted,
        currentHosted: this.currentHosted,
        newHostedURL: this.newHostedURL !== `` ? this.newHostedURL : undefined,
        file:
          this.newAttachedFile !== null
            ? this.newAttachedFile
            : this.attachedFile,
        newFile: this.newAttachedFile !== null ? true : false,
        currentFile: this.attachedFile,
        fileRestricted: this.fileRestricted,
        link: this.post.postLink,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE,
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }

        this.loadingUpdate = false;
        this.$emit("cancelUpdate");
      });
  }

  private get allStatus(): Array<string> {
    return this.$store.getters["common/getStatus"];
  }
}
